export type ScrollAxisName = "vertical" | "horizontal"

export interface ScrollAxis {
  name: ScrollAxisName
  clientSize: "clientHeight" | "clientWidth"
  clientOffset: "clientTop" | "clientLeft"
  scrollSize: "scrollHeight" | "scrollWidth"
  scrollOffset: "scrollTop" | "scrollLeft"
  rectStart: "top" | "left"
  rectEnd: "bottom" | "right"
  rectExtent: "height" | "width"
  crossRectStart: "left" | "top"
  crossRectEnd: "right" | "bottom"
  paddingStart: "paddingTop" | "paddingLeft"
  paddingEnd: "paddingBottom" | "paddingRight"
  overflow: "overflowY" | "overflowX"
  viewportExtent: "height" | "width"
  windowExtent: "innerHeight" | "innerWidth"
}

export interface ViewportPoint {
  x: number
  y: number
}

export const VERTICAL_AXIS: ScrollAxis = {
  name: "vertical",
  clientSize: "clientHeight",
  clientOffset: "clientTop",
  scrollSize: "scrollHeight",
  scrollOffset: "scrollTop",
  rectStart: "top",
  rectEnd: "bottom",
  rectExtent: "height",
  crossRectStart: "left",
  crossRectEnd: "right",
  paddingStart: "paddingTop",
  paddingEnd: "paddingBottom",
  overflow: "overflowY",
  viewportExtent: "height",
  windowExtent: "innerHeight",
}

export const HORIZONTAL_AXIS: ScrollAxis = {
  name: "horizontal",
  clientSize: "clientWidth",
  clientOffset: "clientLeft",
  scrollSize: "scrollWidth",
  scrollOffset: "scrollLeft",
  rectStart: "left",
  rectEnd: "right",
  rectExtent: "width",
  crossRectStart: "top",
  crossRectEnd: "bottom",
  paddingStart: "paddingLeft",
  paddingEnd: "paddingRight",
  overflow: "overflowX",
  viewportExtent: "width",
  windowExtent: "innerWidth",
}

export const SCROLL_AXES: readonly ScrollAxis[] = [VERTICAL_AXIS, HORIZONTAL_AXIS]

export function crossAxisOf(axis: ScrollAxis): ScrollAxis {
  return axis.name === "vertical" ? HORIZONTAL_AXIS : VERTICAL_AXIS
}

export function alongAxis(axis: ScrollAxis, point: ViewportPoint): number {
  return axis.name === "vertical" ? point.y : point.x
}

export function pointOnAxis(axis: ScrollAxis, alongPx: number, acrossPx: number): ViewportPoint {
  return axis.name === "vertical" ? { x: acrossPx, y: alongPx } : { x: alongPx, y: acrossPx }
}
